<template>
  <div>
    <!-- Navbar -->
    <Navbar
      :is-loading="false"
      :vendeur-data="{}"
      :is-sidebar-collapsed="isSidebarCollapsed"
      :is-sidebar-open="isSidebarOpen"
      @toggle-sidebar-collapsed="toggleSidebarCollapsed"
      @toggle-sidebar="toggleSidebar"
      @show-contact-modal="showContactModal = true"
      @show-user-modal="showUserModal = true"
    />

    <div class="w-full">
      <div>
        <!-- Sidebar -->
        <Sidebar
          :is-sidebar-open="isSidebarOpen"
          :is-sidebar-collapsed="isSidebarCollapsed"
          :vendeur-data="{}"
          @toggle-sidebar="toggleSidebar"
        />

        <!-- Overlay pour mobile -->
        <div
          v-if="isSidebarOpen"
          class="sidebar-overlay"
          @click="toggleSidebar"
        ></div>

        <!-- Contenu principal -->
        <main
          class="main-content"
          :class="{ 'sidebar-collapsed': isSidebarCollapsed }"
        >
          <div class="layout">
            <router-view />
          </div>
        </main>
      </div>
    </div>

    <!-- Modals -->
    <ContactModal
      :is-visible="showContactModal"
      @update:is-visible="showContactModal = $event"
    />

    <UserModal
      :is-visible="showUserModal"
      :is-loading="false"
      :vendeur-data="{}"
      @update:is-visible="showUserModal = $event"
      @show-contact-modal="showContactModal = true"
    />

    <!-- Footbar pour mobile -->
    <Footbar />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import {
  Navbar,
  Sidebar,
  ContactModal,
  UserModal,
  Footbar,
} from "@/components";

// État des modals et sidebar
const isSidebarOpen = ref(false);
const showContactModal = ref(false);
const showUserModal = ref(false);
const isSidebarCollapsed = ref(false);

// Fonctions pour gérer l'état
const toggleSidebar = () => {
  isSidebarOpen.value = !isSidebarOpen.value;
};

const toggleSidebarCollapsed = () => {
  isSidebarCollapsed.value = !isSidebarCollapsed.value;
};
</script>

<style lang="scss" scoped>
.sidebar-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 40;
}

@media (min-width: 1024px) {
  .sidebar-overlay {
    display: none;
  }
}

.main-content {
  transition: all 0.3s ease-in-out;
  min-height: 100vh;
  background-color: #f9fafb;

  &.sidebar-collapsed {
    margin-left: 1.5rem;
  }
}

.layout {
  padding: 1.5rem;
}

:deep(.min-h-screen) {
  min-height: calc(100vh - 64px);
}

:deep(.bg-gray-50) {
  background-color: #f9fafb;
}

// Espacement pour les composants enfants
:deep(.PageHeader) {
  margin-bottom: 1.5rem;
}

:deep(.DataCard) {
  margin-bottom: 1.5rem;
}

// Responsive
@media (max-width: 768px) {
  .layout {
    padding: 1rem;
    padding-bottom: 5rem; // Espace pour la footbar
  }

  .main-content {
    margin-left: 0;
    padding-bottom: 60px; // Hauteur de la footbar
  }
}

/* Print layout fixes: hide sidebar spacing and expand content */
@media print {
  .main-content {
    margin-left: 0 !important;
    padding-bottom: 0 !important;
    overflow: visible !important;
    height: auto !important;
  }

  .layout {
    padding-bottom: 0 !important;
    overflow: visible !important;
    height: auto !important;
  }
}
</style>
